import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AttioDealOption, SalesPerson, SubscriptionPriceEstimate, SubscriptionPriceEstimateRequest } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

// **************************************************************************
// QUOTE SUBSCRIPTION CREATE ACTIONS - Price estimation for subscription quotes
// Used in: /home/create-subscription/
// **************************************************************************
export const QuoteSubscriptionCreateActions = createActionGroup({
    source: "Quote Subscription Create",
    events: {
        // =====================================================================
        // PRICE ESTIMATE
        // =====================================================================
        "Load Price Estimate": props<{ request: SubscriptionPriceEstimateRequest }>(),
        "Load Price Estimate Success": props<{ response: SubscriptionPriceEstimate; toastKey: string }>(),
        "Load Price Estimate Failure": props<{ error: AppError; toastKey: string }>(),
        "Reset Price Estimate": emptyProps(),

        // =====================================================================
        // SALESPERSON (decides which Attio deals can be picked)
        // =====================================================================
        "Select Sales Person": props<{ salesPerson: SalesPerson | null }>(),

        // =====================================================================
        // ATTIO DEAL (decides the customer)
        // =====================================================================
        "Select Deal": props<{ deal: AttioDealOption | null }>(),
        "Load Deal Customer Success": emptyProps(),
        "Load Deal Customer Failure": props<{ error: AppError }>(),
    },
});
